import { CardSkeleton } from "@ui/components/Card";

export interface ProgramCardSkeletonProps {
  className?: string;
}

export function ProgramCardSkeleton({ className }: ProgramCardSkeletonProps) {
  return <CardSkeleton className={className} lines={2} withAuthor />;
}
